<app-feed-header [user]="user" (activeTabChanged)="tabChanged($event)"></app-feed-header>
<app-general-feed #feed *ngIf="casesActive || draftsActive" [userId]="userId" [drafts]="draftsActive" [allCases]="false"></app-general-feed>
<app-feed-about *ngIf="aboutActive" [user]="user"></app-feed-about>
